import React, { useEffect } from 'react';

import ConfirmProgramPage from 'components/Members/Programs/Views/New/Confirm/Index';

import { useContext } from 'components/Members/Onboarding/Context';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import { useContext as useProgramContext } from 'components/Members/Programs/Views/Show/Context';

import {
  useParams, useNavigate,
} from 'react-router-dom';

import StepTab from 'components/new_ui/Tabs/StepTab';

import { useContext as useUsersContext } from 'components/Users/Context';

import routes from 'app/routes';

export default function SummaryProgram() {
  const { dispatch, state, actions } = useContext();
  const { dispatch: dispatchProgram, actions: actionsProgram, state: stateProgram } = useProgramContext();

  const { state: stateUser } = useUsersContext();

  const { programId } = useParams();

  const navigate = useNavigate();

  const onGoNextClick = (url) => {
    actions.complete(state.programId, () => {
      if (stateUser.user && stateUser.user.attributes.is_mobile_login) {
        navigate(routes.members.onboarding.webview);
      } else {
        document.location.href = url;
      }
    });
  };

  const onGoPrevClick = () => {
    actions.setPrevStep({
      dispatch,
      steps: state.steps,
      currentStep: state.currentStep,
    });
  };

  useEffect(() => {
    actionsProgram.load(dispatchProgram, programId);
  }, [programId]);

  if (stateProgram.program === null) {
    return (
      <div className="content onboarding-content">
        <section>
          <LoadingPlaceholder text="Loading..." />
        </section>
      </div>
    );
  }

  return (
    <div className="onboarding-content">
      <StepTab total={5} current={5} />

      <ConfirmProgramPage
        showSteps={false}
        onPrevStep={onGoPrevClick}
        onNextStep={onGoNextClick}
      />
    </div>
  );
}
